// Rozpoznanie telefonu a rezimu "pridane na plochu".
//
// Sirka okna sama nestaci: na pocitaci sa da okno zuzit a nikto nechce,
// aby sa pri tom administracia prepla do mobilnej verzie. Preto musi
// sedet sirka AJ dotykove ovladanie.
export const jeTelefon = () => {
  if (typeof window === "undefined") return false;
  const uzke = window.matchMedia("(max-width: 820px)").matches;
  const dotyk = window.matchMedia("(pointer: coarse)").matches;
  return uzke && dotyk;
};

// Aplikacia spustena z ikony na ploche, nie z prehliadaca.
// Android to hlasi cez display-mode, iOS cez vlastne navigator.standalone.
export const jeZPlochy = () => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};
